import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested, isNotEmpty } from 'class-validator';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';

export class LivetvDTO {
  @ApiProperty()
  @ApiPropertyOptional()
  Id?: number;
  @ApiProperty()
  @MaxLength(500, { message: "livetv tittle Code allows maximum 500 characters" })
  livetvTitle:string;
  @ApiProperty()
  @MaxLength(500, { message: "livetv message Code allows maximum 500 characters" })
  livetvMessage:string;
  @ApiProperty()
  @MaxLength(500, { message: "livetv url Code allows maximum 500 characters" })
  livetvUrl:string;
  @ApiProperty()
  @ApiPropertyOptional()
  livetvThumbnail?:string;
  @ApiProperty({ type: 'array', items: { type: 'string', format: 'binary' } , description:'upload image type:file'})
  thumbnailImg:any[];
  @ApiProperty()
  status: boolean;
  createdAt : Date;
  @ApiProperty()
  @ApiPropertyOptional()
  createdUser : number;
  updatedAt : Date;
  @ApiProperty()
  @ApiPropertyOptional()
  updatedUser : number;
  @ApiProperty()
  versionFlag : number;
}

export class EditLivetvDTO {
  @ApiProperty()
  Id?: number;
  @ApiProperty()
  @MaxLength(500, { message: "livetv url Code allows maximum 500 characters" })
  livetvUrl:string;
  updatedAt : Date;
  @ApiProperty()
  @ApiPropertyOptional()
  updatedUser : number;
  @ApiProperty()
  @ApiPropertyOptional()
  versionFlag : number;
}

export class livetvStatusDTO {
    @ApiProperty()
    @IsNotEmpty({message:"Id should not be empty"})
    @IsNumber()
    Id: number;
    @ApiProperty()
    status: boolean;
    updatedAt : Date;
    @ApiProperty()
    @IsOptional()
    updatedUser : number;
}

  export class livetvActiveDTO {
    @ApiProperty()
    @IsNotEmpty({message:"Id should not be empty"})
    @IsNumber()
    Id: number;
    @ApiProperty()
    isActive: number;
    updatedAt : Date;
    @ApiProperty()
    updatedUser : number;
  }